<template>
	<div
		:class="{radio: true, 'radio--checked': checked}"
		@click.prevent="
			$emit('change', checked ? (emitValueOnUncheck ? [value, n] : null) : [value, n])
		"
		@mouseover="onmouseover"
		@mouseleave="onmouseleave"
	>
		<label class="radio__container">
			<span
				:class="['radio__checkmark', 'radio__checkmark' + cssSuffix, {'--checked': checked}]"
			></span>
			<span class="radio__text">
				<span class="radio__text--left">
					<slot></slot>
				</span>
				<span class="radio__text--input">
					<template v-if="$slots['right-addon']">
						<slot name="right-addon"></slot>
					</template>
					<span class="radio__input-wrapper">
						<input
							@click.stop="() => {}"
							v-model="n"
							@change="$emit('change', [value, n])"
							:name="name"
							type="number"
							min="1"
							step="1"
							:disabled="!checked"
						/>
						<slot name="right-addon-2"></slot>
					</span>
				</span>
			</span>
		</label>
	</div>
</template>

<script>
export default {
	props: {
		value: {type: String, required: true},
		name: {type: String, required: true},
		number: {type: Number, required: true},
		checked: {type: Boolean, required: true},
		checkbox: {type: Boolean, required: false},
		emitValueOnUncheck: {type: Boolean, default: false},
		onmouseover: {type: Function, default: () => {}},
		onmouseleave: {type: Function, default: () => {}},
	},
	data() {
		return {
			n: 1,
		};
	},
	computed: {
		cssSuffix() {
			return this.checkbox ? '--checkbox' : '--radio';
		},
	},
	mounted() {
		this.n = this.number || 1;
	},
};
</script>
